<template>
  <RemainingPicks v-bind="{ remaining }">
    <template #done>
      {{ $t('numberlottery.remainingnumbers.done') }}
    </template>

    <i18n-t keypath="numberlottery.remainingnumbers" scope="global">
      <template #name>
        {{ name }}
      </template>

      <template #remaining>
        <RemainingPicksBubble v-bind="{ remaining }" />
      </template>
    </i18n-t>
  </RemainingPicks>
</template>

<script lang="ts" setup>
type NumberLotteryBaseRemainingNumbersProps = {
  fieldName: string
  remaining: number
}

const props = defineProps<NumberLotteryBaseRemainingNumbersProps>()
const { t } = useI18n()
const { lotteryId } = useRoute().params

const name = computed(() => {
  const suffix = props.fieldName === 'BASE' ? 'base' : `extra.${String(lotteryId)}`
  return t(`numberlottery.remainingnumbers.name.${suffix}`, props.remaining)
})
</script>
